import {
  Component,
  NgModule,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  model,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {
  FormArray,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { Observable, forkJoin } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DynamicFormQuestionComponent } from '../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { EmployeeService } from '../../inputfileds/form_services/employee/employee.service';
import { ApiservicesService } from '../../Services/Apis/apiservices.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UploadDialogComponent } from '../../components/upload-dialog/upload-dialog.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { PaginationComponent } from '../../components/pagination/pagination.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ToastService } from '../../Services/toast/toast.service';
import { ToastComponent } from '../../components/toast/toast.component';
import { environment } from '../../../environments/environment';
import { DropdownservicesService } from '../../Services/Apis/Dropdownservices/dropdownservices.service';
import { PermissionService } from '../../components/Authentication/services/permission.service';
import { ConnectiveservicesService } from '../../Services/Apis/Connectiveservices/connectiveservices.service';
import { Location } from '@angular/common';
import { TranslatePipe } from '../../components/Utilites/Pipe/translate.pipe';
import { TranslateDirective } from '../../components/Utilites/Directives/translate.directive';
import { Store } from '@ngrx/store';

export interface Employee {
  index: number;
  Name: number;
  Dost_ID: string;
  Roll_No: string;
  Department: string;
  Academic_Year: string;
  Action: any;
}

export interface Employeeeducation {
  id: number;
  qualification_id: string;
  start_year: string;
  end_year: string;
  university_name: string;
  institution_name: string;
  course_name: string;
  percentage: string;
}
export interface EmployeeFormdata {
  personal_details: {
    organization_id?: string;
    employee_unique_id?: string;
    title?: string;
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    personal_email?: string;
    father_name?: string;
    mother_name?: string;
    phone_number?: string;
    alternate_mobile_number?: string;
    password?: string;
    religion_id?: string;
    caste_id?: string;
    sub_caste?: string;
    gender_id?: string;
    date_of_birth?: string;
    adhar_number?: string;
    pan_number?: string;
    user_role_id?: string;
    status_id?: string;
    // "status": "ACTIVE"
  };
  educational_qualifications: [
    {
      id: number;
      qualification_id?: number;
      qualification?: string;
      start_year?: string;
      end_year?: string;
      university_name?: string;
      institution_name?: string;
      course_name?: string;
      percentage?: string;
    },
  ];
  addresses: [
    {
      country_id?: string;
      state_id?: string;
      address_line1?: string;
      address_line2?: string;
      pincode?: string;
      city?: string;
    },
    {
      country_id?: string;
      state_id?: string;
      address_line1?: string;
      address_line2?: string;
      pincode?: string;
      city?: string;
    },
  ];
  experience: {
    id: number;
    designation?: string;
    organization_name?: string;
    start_year?: string;
    end_year?: string;
    location?: string;
  };
  salary_deatails: {
    pay_scale?: string;
    pf_number?: string;
    esi_number?: string;
    salary_mode_id?: string;
    gross_pay_per_month?: string;
    hra_in_rupees?: string;
    basic_pay?: string;
    other_allowances?: string;
    bank_account_number?: string;
    bank_ifsc_code?: string;
    bank_name?: string;
    bank_branch_name?: string;
  };
  joining_details: {
    professional_email: string;
    // "employement_type_id": string,
    appointment_type_id: string;
    department_id: string;
    faculty_teaching_for: string;
    designation_id: string;
    date_of_joining: string;
    // "date_of_relieving": string
  };
}

export interface personal_details_model {
  organization_id: number;
  employee_unique_id: string;
  title: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  personal_email: string;
  father_name: string;
  mother_name: string;
  phone_number: string;
  alternate_mobile_number: string;
  // "password": "Welcome@123",
  religion_id: number;
  caste_id: number;
  sub_caste: string;
  gender_id: number;
  date_of_birth: string;
  adhar_number: string;
  pan_number: string;
  user_role_id: number;
  status_id: number;
}
@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss'],
  imports: [
    // PaginationComponent,
    MatPaginatorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatButtonModule,
    MatInputModule,
    MatTableModule,
    MatCheckboxModule,
    DynamicFormQuestionComponent,
    MatIconModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatSnackBarModule,
    MatDialogModule,
    ToastComponent,
    TranslateDirective,
  ],
  standalone: true,
})
export class EmployeeComponent implements OnInit {
  EmployeeProfileFormQuestions: any[] = [];
  EmployeeProfileFormQuestions$: Observable<any[]> | null = null;
  EmployeeProfileForm!: FormGroup;
  EmployeePresentAddressForm!: FormGroup;
  EmployeePermanentAddressForm!: FormGroup;
  EmployeeExperienceForm!: FormGroup;
  EmployeeScholarly_workForm!: FormGroup;
  EmployeeJoiningForm!: FormGroup;
  EmployeeSalaryForm!: FormGroup;
  EmployeeBankdetailsForm!: FormGroup;
  EmployeeFilterForm!: FormGroup;
  EmployeeeAddresscheckboxForm!: FormGroup;
  form2!: FormGroup;
  EmployeeEducationForm!: FormGroup;
  payLoad = '';
  EmployeeAddressFormQuestions: any[] | null = [];
  EmployeeEducationFormQuestions: any[] | null = [];
  EmployeeExperienceFormQuestions: any[] | null = [];
  EmployeeScholarly_workFormQuestions: any[] | null = [];
  EmployeeJoiningFormQuestions: any[] | null = [];
  EmployeeSalaryFormQuestions: any[] | null = [];
  EmployeeBankdetailsFormQuestions: any[] | null = [];
  EmployeeeAddresscheckboxQuestions: any[] | null = [];
  EmployeeAddressFormQuestions$: Observable<any[]> | null = null;
  EmployeeEducationFormQuestions$: Observable<any[]> | null = null;
  EmployeeExperienceFormQuestions$: Observable<any[]> | null = null;
  EmployeeScholarly_workFormQuestions$: Observable<any[]> | null = null;
  EmployeeJoiningFormQuestions$: Observable<any[]> | null = null;
  EmployeeSalaryFormQuestions$: Observable<any[]> | null = null;
  EmployeeBankdetailsFormQuestions$: Observable<any[]> | null = null;
  EmployeeeAddresscheckboxQuestions$: Observable<any[]> | null = null;
  EmployeeFilterFormQuestions: any[] = [];
  EmployeeFilterFormQuestions$: Observable<any[]> | null = null;
  getEmployeeData = [];
  displayedColumns: string[] = [
    'Name',
    'email',
    'phone_number',
    'employee_unique_id',
    'designation_name',
    'organization_name',
    'Action',
  ];
  dataSource = new MatTableDataSource<Employee>(this.getEmployeeData);
  selection = new SelectionModel<Employee>(true, []);
  educationaddform = this.fb.group({});
  educationaddformarry: any = [];
  experienceaddformarry: any = [];
  scholarly_workaddformarry: any = [];
  addressesformarry: any = [];
  showuploadconfirm: boolean = false;
  console = console;
  filterdata: any[] | undefined;
  pipe = new DatePipe('en-US');
  errorMessage: string | null = null;
  checked: boolean = false;
  url: string | ArrayBuffer | null | undefined;
  readonly indeterminate = model(false);
  paginationdata: any;
  total_count: any;
  file: File | null = null;
  dataId: number | null = null;
  fileName: string | null = null;
  selectedImageUrl: string | ArrayBuffer | null = null;
  selectedFilter = '';
  @ViewChild(MatMenuTrigger) filterMenu!: MatMenuTrigger;
  filters: any;
  isEditMode: boolean = false;
  editingEmployeeId: number | null = null;
  editeducationarrayflag: boolean = true;
  editexperiencearrayflag: boolean = true;
  editscholarly_workarrayflag: boolean = true;
  editeducationindex: any;
  editexperienceindex: any;
  editscholarly_workindex: any;
  editeducationid: any;
  editexperienceid: any;
  editscholarly_workid: any;
  qualificationdropdata: any;
  actiondata: any;
  editdataappend: any;
  present_selected_country_name: any;
  present_selected_state_name: any;
  premenent_selected_country_name: any;
  premenent_selected_state_name: any;
  empformcontrols: any;

  constructor(
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private EmployeeService: EmployeeService,
    private apiservice: ApiservicesService,
    private dropdownservice: DropdownservicesService,
    private connectiveservice: ConnectiveservicesService,
    // private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private router: Router,
    private toast: ToastService,
    private location: Location,
    private store: Store,
    private permissionService: PermissionService,
  ) {
    // this.actiondata = this.permissionService?.getactiondata();
    // if (this.actiondata?.view === false && this.actiondata?.edit === false) {
    //   this.displayedColumns.splice(this.displayedColumns.indexOf('actions'), 1);
    // }
    this.getemployeelist();
    this.EmployeeFilterForm = this.fb.group({
      department_id: [''],
    });
  }

  getemployeelist(departmentId?: any) {
    this.filters = { departmentId };
    this.apiservice
      .getemployeelist(this.paginationdata, this.filters)
      .subscribe((res: any) => {
        this.dataSource = new MatTableDataSource<Employee>(res?.rows);
        this.total_count = res.total_count;
      });
  }

  getQulificationdata() {
    this.dropdownservice
      .getlookupcodesdropdown('QUALIFICATIONS')
      .subscribe((res: any) => {
        this.qualificationdropdata = res;
      });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: Employee): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.index + 1
    }`;
  }

  ngOnInit() {
    this.EmployeeProfileForm = this.fb.group({});
    this.EmployeePresentAddressForm = this.fb.group({});
    this.form2 = this.fb.group({});
    this.EmployeeEducationForm = this.fb.group({});
    this.EmployeeExperienceForm = this.fb.group({});
    this.EmployeeScholarly_workForm = this.fb.group({});
    this.EmployeeJoiningForm = this.fb.group({});
    this.EmployeeSalaryForm = this.fb.group({});
    this.EmployeeBankdetailsForm = this.fb.group({});
    this.EmployeeeAddresscheckboxForm = this.fb.group({});
    this.EmployeePermanentAddressForm = this.fb.group({});
    this.EmployeeProfileFormQuestions$ = this.EmployeeService.getfilterformdata(
      'personal_details',
      this.EmployeeService.getemployeeform(),
    );
    this.EmployeeAddressFormQuestions$ = this.EmployeeService.getfilterformdata(
      'addresses',
      this.EmployeeService.getAddressForm(),
    );
    this.EmployeeEducationFormQuestions$ =
      this.EmployeeService.getfilterformdata(
        'educational_qualifications',
        this.EmployeeService.getEducationalDetails(),
      );
    this.EmployeeExperienceFormQuestions$ =
      this.EmployeeService.getfilterformdata(
        'experience',
        this.EmployeeService.getExperienceForm(),
      );
    this.EmployeeScholarly_workFormQuestions$ =
      this.EmployeeService.getfilterformdata(
        'scholarly_work',
        this.EmployeeService.getScholarly_workForm(),
      );
    this.EmployeeJoiningFormQuestions$ = this.EmployeeService.getfilterformdata(
      'joining_details',
      this.EmployeeService.getJoiningFrom(),
    );
    this.EmployeeSalaryFormQuestions$ = this.EmployeeService.getfilterformdata(
      'salary_details',
      this.EmployeeService.getSalaryForm(),
    );
    this.EmployeeBankdetailsFormQuestions$ =
      this.EmployeeService.getfilterformdata(
        'bank_details',
        this.EmployeeService.getBankdetailsForm(),
      );
    this.EmployeeeAddresscheckboxQuestions$ =
      this.EmployeeService.getPermanetcheckbox();

    this.EmployeeProfileFormQuestions$?.subscribe((q) => {
      this.EmployeeProfileFormQuestions = q;
      this.populateFormGroups();
    });

    this.EmployeeAddressFormQuestions$.subscribe((q) => {
      this.EmployeeAddressFormQuestions = q;
      this.populateFormGroups();
    });

    this.EmployeeEducationFormQuestions$.subscribe((q) => {
      this.EmployeeEducationFormQuestions = q;
      this.populateFormGroups();
    });

    this.EmployeeExperienceFormQuestions$.subscribe((q) => {
      this.EmployeeExperienceFormQuestions = q;
      this.populateFormGroups();
    });

    this.EmployeeScholarly_workFormQuestions$.subscribe((q) => {
      this.EmployeeScholarly_workFormQuestions = q;
      this.populateFormGroups();
    });

    this.EmployeeJoiningFormQuestions$.subscribe((q) => {
      this.EmployeeJoiningFormQuestions = q;
      this.populateFormGroups();
    });

    this.EmployeeSalaryFormQuestions$.subscribe((q) => {
      this.EmployeeSalaryFormQuestions = q;
      this.populateFormGroups();
    });

    this.EmployeeBankdetailsFormQuestions$.subscribe((q) => {
      this.EmployeeBankdetailsFormQuestions = q;
      this.populateFormGroups();
    });

    this.EmployeeeAddresscheckboxQuestions$.subscribe((q) => {
      this.EmployeeeAddresscheckboxQuestions = q;
      this.populateFormGroups();
    });

    this.filterdata = [...this.EmployeeProfileFormQuestions];
    this.filterdata.splice(0, 6);

    if (this.connectiveservice.Employee_data) {
      this.editdata(this.connectiveservice.Employee_data);
    } else {
      this.getQulificationdata();
    }
  }

  populateFormGroups() {
    for (const question of this.EmployeeProfileFormQuestions) {
      this.EmployeeProfileForm.addControl(
        question.key,
        this.fb.control('', <any>question?.required ? Validators.required : []),
      ); // Ensure 'organization_id' is properly added
    }

    for (const question of this.EmployeeAddressFormQuestions || []) {
      this.EmployeePresentAddressForm.addControl(
        question.key,
        this.fb.control('', <any>question?.required ? Validators.required : []),
      );
    }

    for (const question of this.EmployeeAddressFormQuestions || []) {
      this.EmployeePermanentAddressForm.addControl(
        question.key,
        this.fb.control('', <any>question?.required ? Validators.required : []),
      );
    }

    for (const question of this.EmployeeEducationFormQuestions || []) {
      this.EmployeeEducationForm.addControl(
        question.key,
        this.fb.control('', <any>question?.required ? Validators.required : []),
      );
    }

    for (const question of this.EmployeeExperienceFormQuestions || []) {
      this.EmployeeExperienceForm.addControl(
        question.key,
        this.fb.control(
          question.type === 'number' ? <number>0 : <string>'',
          <any>question?.required ? Validators.required : [],
        ),
      );
    }

    for (const question of this.EmployeeScholarly_workFormQuestions || []) {
      this.EmployeeScholarly_workForm.addControl(
        question.key,
        this.fb.control(
          question.type === 'number' ? <number>0 : <string>'',
          <any>question?.required ? Validators.required : [],
        ),
      );
    }

    for (const question of this.EmployeeJoiningFormQuestions || []) {
      this.EmployeeJoiningForm.addControl(
        question.key,
        this.fb.control('', <any>question?.required ? Validators.required : []),
      );
    }

    for (const question of this.EmployeeSalaryFormQuestions || []) {
      this.EmployeeSalaryForm.addControl(
        question.key,
        this.fb.control('', <any>question?.required ? Validators.required : []),
      );
    }

    for (const question of this.EmployeeBankdetailsFormQuestions || []) {
      this.EmployeeBankdetailsForm.addControl(
        question.key,
        this.fb.control('', <any>question?.required ? Validators.required : []),
      );
    }

    for (const question of this.EmployeeeAddresscheckboxQuestions || []) {
      this.EmployeeeAddresscheckboxForm.addControl(
        question.key,
        this.fb.control('', <any>question?.required ? Validators.required : []),
      );
    }
    // for (const question of this.EmployeeFilterFormQuestions || []) {
    //   this.EmployeeFilterForm.addControl(question.key, this.fb.control('', <any>question?.required ? Validators.required : []));
    // }

    // this.form2 = this.fb.group({
    //   educational_qualifications: this.fb.array([this.initTimes()]),
    // });
  }

  // ngDoCheck(){
  //   if(this.EmployeePresentAddressForm.value.country_id !== null){
  //     var array : any = []
  //     this.apiservice.getlookupcodesdropdown('INDIA').subscribe((course) => {
  //       for (let i = 0; i <= course.length; i++) {
  //         array?.push({ id: course[i].id, key: course[i].name, value: course[i].id })
  //       }
  //     });
  //     // this.EmployeeAddressFormQuestions[1].options
  //   }
  // }
  // initTimes() {
  //   for (const question of this.EmployeeEducationFormQuestions || []) {
  //     this.educationaddform.addControl(question.key, this.fb.control('', <any>question?.required ? Validators.required : []));
  //   }
  //   return this.educationaddform
  // }

  // objectToFormGroup(obj: any): FormGroup {
  //   const formGroup = this.fb.group({});

  //   // Iterate over the keys in the object
  //   Object.keys(obj).forEach(key => {
  //     // Create a FormControl for each key-value pair and add it to the FormGroup
  //     formGroup.addControl(key, new FormControl(obj[key]));
  //   });

  //   return formGroup;
  // }

  changingids(event: any, index: number) {
    // event.id = event.key + index;
    // return event;
    return {
      ...event,
      id: `${event.key}${index}`,
    };
  }

  resetemployeeform() {
    // this.isEditMode = false;
    this.EmployeeProfileForm.reset();
    this.EmployeeEducationForm.reset();
    this.EmployeeExperienceForm.reset();
    this.EmployeeJoiningForm.reset();
    this.EmployeePresentAddressForm.reset();
    this.EmployeePermanentAddressForm.reset();
    this.EmployeeSalaryForm.reset();
    // this.EmployeeBankdetailsForm.reset();
    this.educationaddformarry = [];
    this.experienceaddformarry = [];
    this.scholarly_workaddformarry = [];
    this.addressesformarry = [];
    this.EmployeeeAddresscheckboxForm.reset();
  }

  // get fa() {
  //   return this.form2.get('educational_qualifications') as FormArray;
  // }

  // addGroup() {
  //   this.fa.push(this.initTimes());
  // }

  // removeGroup(i: number) {
  //   this.fa.removeAt(i);
  // }

  gotoemplyeeview(event: any) {
    this.router.navigate(['employeeview'], {
      queryParams: { dataId: event.id },
    });
  }
  filterEmployees(event: Event) {
    const formValues = this.EmployeeFilterForm.value;
    this.getemployeelist(formValues.department_id);
    this.filterMenu.closeMenu();
  }

  clearFilter() {
    this.EmployeeFilterForm.reset();
    this.getemployeelist(); // Reset to the unfiltered list
    this.filterMenu.closeMenu(); // Optionally close the menu after clearing
  }

  // ngAfterViewInit() {
  //   this.cdr.detectChanges();
  // }

  getfirtformdata() {}

  arraySubmit() {
    if (this.EmployeeEducationForm.valid) {
      this.educationaddformarry.push(this.EmployeeEducationForm.getRawValue());
      // this.educationaddformarry.map((data:any) => {
      // let filterqualificationdata = this.qualificationdropdata.find((e:any)=>{
      //     e.id == this.educationaddformarry.qualification_id;
      //   })
      // this.educationaddformarry = { ...this.educationaddformarry, qualification: filterqualificationdata};
      // })
      // this.openSnackBar();
      this.EmployeeEducationForm.reset();
      this.editeducationarrayflag = true;
    }
  }

  menuClosed(event: any) {}

  editarrySubmit() {
    // this.educationaddformarry[this.editeducationindex].append(
    //   this.EmployeeEducationForm.getRawValue()
    // );
    this.educationaddformarry[this.editeducationindex] =
      this.EmployeeEducationForm.getRawValue();
    this.educationaddformarry[this.editeducationindex].id =
      this.editeducationid;
    this.reseteducationform();
    this.editeducationarrayflag = true;
    this.editeducationindex = null;
  }
  reseteducationform() {
    this.EmployeeEducationForm.reset();
    this.editeducationarrayflag = true;
    this.editeducationindex = null;
  }

  editarrayform(event: any, index: number) {
    this.editeducationarrayflag = false;
    this.editeducationindex = index;
    this.editeducationid = event.id;
    this.EmployeeEducationForm.patchValue(event);
  }

  editarraysubmit(event: any) {}

  deletearrayform(event: number) {
    this.educationaddformarry.splice(event, 1);
  }

  // scholarly_work Array Functions Start Here

  scholarly_workarraySubmit() {
    if (this.EmployeeScholarly_workForm.valid) {
      this.scholarly_workaddformarry.push(
        this.EmployeeScholarly_workForm.getRawValue(),
      );
      this.EmployeeScholarly_workForm.reset();
      this.editscholarly_workarrayflag = true;
    }
  }

  editscholarly_workarrySubmit() {
    this.scholarly_workaddformarry[this.editscholarly_workindex] =
      this.EmployeeScholarly_workForm.getRawValue();
    this.scholarly_workaddformarry[this.editscholarly_workindex].id =
      this.editscholarly_workid;
    this.resetscholarly_workform();
    this.editscholarly_workarrayflag = true;
    this.editscholarly_workindex = null;
  }
  resetscholarly_workform() {
    this.EmployeeScholarly_workForm.reset();
    this.editscholarly_workarrayflag = true;
    this.editscholarly_workindex = null;
  }

  editscholarly_workarrayform(event: any, index: number) {
    this.editscholarly_workarrayflag = false;
    this.editscholarly_workindex = index;
    this.editscholarly_workid = event.id;
    this.EmployeeScholarly_workForm.patchValue(event);
  }

  editscholarly_workarraysubmit(event: any) {}

  deletescholarly_workarrayform(event: number) {
    this.scholarly_workaddformarry.splice(event, 1);
  }

  // End of scholarly_work Array Functions

  // Experience Array Functions Start Here

  experiencearraySubmit() {
    if (this.EmployeeExperienceForm.valid) {
      this.experienceaddformarry.push(
        this.EmployeeExperienceForm.getRawValue(),
      );
      this.EmployeeExperienceForm.reset();
      this.editexperiencearrayflag = true;
    }
  }

  editexperiencearrySubmit() {
    this.experienceaddformarry[this.editexperienceindex] =
      this.EmployeeExperienceForm.getRawValue();
    this.experienceaddformarry[this.editexperienceindex].id =
      this.editexperienceid;
    this.resetexperienceform();
    this.editexperiencearrayflag = true;
    this.editexperienceindex = null;
  }
  resetexperienceform() {
    this.EmployeeExperienceForm.reset();
    this.editexperiencearrayflag = true;
    this.editexperienceindex = null;
  }

  editexperiencearrayform(event: any, index: number) {
    this.editexperiencearrayflag = false;
    this.editexperienceindex = index;
    this.editexperienceid = event.id;
    this.EmployeeExperienceForm.patchValue(event);
  }

  editexperiencearraysubmit(event: any) {}

  deleteexperiencearrayform(event: number) {
    this.experienceaddformarry.splice(event, 1);
  }

  // End of Experience Array Functions

  openSnackBar() {
    this.snackBar.open(
      'Education details Added to the Form. you can modify/delete the Details by clicking on the menu option. also you can add more other educational details by repeating the same steps.',
      'cancel',
      {
        duration: 3000,
      },
    );
  }

  convertStoN(event: FormGroup) {
    Object.keys(event.controls).forEach((key) => {
      if (!event.value[key]) {
        event.patchValue({ [key]: null });
      }
    });
    return event;
  }

  addresscheckbox() {
    if (this.checked) {
      this.EmployeePermanentAddressForm.setValue(
        this.EmployeePresentAddressForm.getRawValue(),
      );
    } else {
      this.EmployeePermanentAddressForm.reset();
    }
  }

  imageInputChange(fileInputEvent: any): void {
    this.file = fileInputEvent.target.files[0];
    this.fileName = fileInputEvent.target.files[0].name;
    if (this.file) {
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = () => {
        this.selectedImageUrl = reader.result;
      };
    }
  }

  updateimage(file: File, id: number) {
    this.apiservice.updateemployeeimage(file, id).subscribe((res) => {
      this.getemployeelist();
    });
  }

  updateImage(file: File, id: number): void {
    this.apiservice.updateemployeeimage(file, id).subscribe(
      (res) => {
        this.getemployeelist();
      },
      (err) => {
        this.errorMessage = 'Image upload failed. Please try again.';
      },
    );
  }

  getcountryname(id: number, type?: string) {
    const countryd_name = this.EmployeeService.Countrydata.find(
      (element: any) => element.id == id,
    );
    if (type === 'permenent') {
      this.premenent_selected_country_name = countryd_name.key
        ? countryd_name.key
        : '';
    } else {
      this.present_selected_country_name = countryd_name.key
        ? countryd_name.key
        : '';
    }
  }

  getstatename(id: number, type?: string) {
    const statee_name = this.EmployeeService.Statedata.find(
      (element: any) => element.id == id,
    ).key;
    if (type === 'permenent') {
      this.premenent_selected_state_name = statee_name ? statee_name : '';
    } else {
      this.present_selected_state_name = statee_name ? statee_name : '';
    }
  }

  onSubmit() {
    // this.convertStoN(this.EmployeeExperienceForm);
    let payload = {
      ...this.EmployeeProfileForm.getRawValue(),
      // ...this.EmployeePresentAddressForm.getRawValue(),
      // ...this.EmployeeEducationForm.getRawValue(),
      // ...this.convertStoN(this.EmployeeExperienceForm).getRawValue(),
      ...this.EmployeeExperienceForm.getRawValue(),
      ...this.EmployeeJoiningForm.getRawValue(),
      ...this.EmployeeSalaryForm.getRawValue(),
      // ...this.EmployeePermanentAddressForm.getRawValue()
    };

    // let addreess: any[] = [];
    const presentAddress = this.EmployeePresentAddressForm.getRawValue();
    this.getcountryname(presentAddress.country_id, 'persent');
    this.getstatename(presentAddress.state_id, 'persent');
    presentAddress.country_name = this.present_selected_country_name;
    presentAddress.state_name = this.present_selected_state_name;
    this.addressesformarry.push(presentAddress);
    // if(!this.checked){
    const permanentAddress = this.EmployeePermanentAddressForm.getRawValue();
    this.getcountryname(permanentAddress.country_id, 'permenent');
    this.getstatename(permanentAddress.state_id, 'permenent');
    permanentAddress.country_name = this.premenent_selected_country_name;
    permanentAddress.state_name = this.premenent_selected_state_name;
    this.addressesformarry.push(permanentAddress);
    // }

    let role_status: any[] = [];
    role_status.push({
      role_id: parseInt(this.EmployeeProfileForm.value.user_role_id),
    });
    let apiObjecttosend = {
      personal_details: {
        // organization_id: parseInt(
        //   this.EmployeeProfileForm.value.organization_id
        // ),
        employee_unique_id: this.EmployeeProfileForm.value?.employee_unique_id,
        title: this.EmployeeProfileForm.value.title,
        first_name: this.EmployeeProfileForm.value.first_name,
        middle_name: this.EmployeeProfileForm.value.middle_name,
        last_name: this.EmployeeProfileForm.value.last_name,
        personal_email: this.EmployeeProfileForm.value.personal_email,
        father_name: this.EmployeeProfileForm.value.father_name,
        mother_name: this.EmployeeProfileForm.value.mother_name,
        phone_number: this.EmployeeProfileForm.value.phone_number,
        alternate_mobile_number:
          this.EmployeeProfileForm.value.alternate_mobile_number,
        password: this.EmployeeProfileForm.value.password,
        religion_id: parseInt(this.EmployeeProfileForm.value.religion_id),
        // "religion": this.EmployeeProfileForm.value.religion,
        caste_id: parseInt(this.EmployeeProfileForm.value.caste_id),
        caste: this.EmployeeProfileForm.value.caste,
        sub_caste: this.EmployeeProfileForm.value.sub_caste,
        gender_id: parseInt(this.EmployeeProfileForm.value.gender_id),
        // "gender": this.EmployeeProfileForm.value.gender,
        date_of_birth: this.pipe.transform(
          this.EmployeeProfileForm.value.date_of_birth,
          'yyyy-MM-dd',
        ),
        adhar_number: this.EmployeeProfileForm.value?.adhar_number?.toString(),
        pan_number: this.EmployeeProfileForm.value.pan_number,
        user_roles: role_status,
        // "user_role": this.EmployeeProfileForm.value.userRole,
        status_id: parseInt(this.EmployeeProfileForm.value.status_id),
        // "status": 'ACTIVE'
      },
      educational_qualifications: this.educationaddformarry,
      addresses: this.addressesformarry,
      experience: this.experienceaddformarry,
      scholarly_work: this.scholarly_workaddformarry,
      salary_deatails: {
        pay_scale: this.EmployeeSalaryForm.value.pay_scale,
        pf_number: this.EmployeeSalaryForm.value?.pf_number?.toString(),
        esi_number: this.EmployeeSalaryForm.value?.esi_number?.toString(),
        salary_mode_id: parseInt(this.EmployeeSalaryForm.value.salary_mode_id),
        // "salary_mode": this.EmployeeSalaryForm.value.salary_mode,
        gross_pay_per_month:
          this.EmployeeSalaryForm.value?.gross_pay_per_month?.toString(),
        hra_in_rupees: this.EmployeeSalaryForm.value?.hra_in_rupees?.toString(),
        basic_pay: this.EmployeeSalaryForm.value?.basic_pay?.toString(),
        other_allowances:
          this.EmployeeSalaryForm.value?.other_allowances?.toString(),
        bank_account_number:
          this.EmployeeBankdetailsForm.value?.bank_account_number?.toString(),
        bank_ifsc_code:
          this.EmployeeBankdetailsForm?.value.bank_ifsc_code?.toString(),
        bank_name: this.EmployeeBankdetailsForm.value?.bank_name?.toString(),
        bank_branch_name:
          this.EmployeeBankdetailsForm.value?.bank_branch_name?.toString(),
      },
      joining_details: {
        employment_type_id: this.EmployeeJoiningForm.value.employment_type_id,
        professional_email: this.EmployeeJoiningForm.value.professional_email,
        // "employement_type": this.EmployeeJoiningForm?.value?.employement_type,
        appointment_type_id: this.EmployeeJoiningForm.value.appointment_type_id,
        // "appointment_type": this.EmployeeJoiningForm?.value?.appointment_type,
        department_id: this.EmployeeJoiningForm.value.department_id,
        // "department_name": this.EmployeeJoiningForm.value.EmployeeJoiningForm,
        faculty_teaching_for:
          this.EmployeeJoiningForm.value.faculty_teaching_for,
        designation_id: this.EmployeeJoiningForm.value.designation_id,
        // "designation_name": this.EmployeeJoiningForm.value.designation_name,
        date_of_joining: this.pipe.transform(
          this.EmployeeJoiningForm.value.date_of_joining,
          'yyyy-MM-dd',
        ),
        // date_of_relieving: this.pipe.transform(
        //   this.EmployeeJoiningForm.value.date_of_relieving,
        //   'yyyy/MM/dd'
        // ),
      },
    };

    // this.getstatename(this.EmployeePresentAddressForm.value.state_id);
    payload = { ...payload, addresses: this.addressesformarry };
    if (this.editingEmployeeId !== null) {
      this.updateEmployee(this.editingEmployeeId);
    } else {
      this.createAPi(apiObjecttosend);
    }
  }

  createAPi(event: any) {
    this.apiservice.createemployees(event).subscribe((res: any) => {
      if (res.code === 201 && res.status === true) {
        this.present_selected_country_name = null;
        this.present_selected_state_name = null;
        this.premenent_selected_country_name = null;
        this.premenent_selected_state_name = null;
        this.toast.showToast('success', 'Employee Created Successfully');
        this.resetemployeeform();
        this.NavigateToBack();
        if (this.file) {
          this.updateImage(this.file, res.data.id);
        }
      } else {
        this.toast.showToast('danger', `Error: ${res.message}`);
        this.errorMessage = res.message;
      }
    });
  }

  editemployee(event: string) {
    return this.empformcontrols?.[event].reduce((acc: any, el: any) => {
      if (!el.hidden) {
        acc[el.key] = this.editdataappend[event][el.key];
      }
      return acc;
    }, {});
  }

  isEmployeeFieldVisible(section: string, fieldKey: string): boolean {
    const controls = this.empformcontrols?.[section] || [];

    return controls.some(
      (el: any) => el.key === fieldKey && el.hidden === false,
    );
  }

  editdata(event: any) {
    this.store
      .select((state: any) => state.empform)
      .subscribe((res: any) => {
        this.empformcontrols = res?.Employeeform;
      });

    this.EmployeeProfileForm.controls['password'].disable();
    // this.EmployeeProfileForm.removeControl('password');
    this.EmployeeProfileForm.controls['user_role_id'].disable();
    // this.EmployeeProfileForm.controls['password'].clearValidators();
    // this.EmployeeProfileForm.controls['password'].setErrors(null);
    // this.EmployeeProfileForm.controls['password'].setValidators(null);
    this.isEditMode = true;
    // let this.editdataappend: any;
    this.resetemployeeform();
    this.editingEmployeeId = event.id;
    this.apiservice
      .getemployeedetails(event.id)
      .subscribe((events: EmployeeFormdata) => {
        this.editdataappend = events;
        let personalDetails = {
          ...this.editemployee('personal_details'),
          password: 'Rimmi@123456',
          user_role_id:
            this.editdataappend?.personal_details?.user_roles[0]
              ?.user_role_type_id,
        };
        const editdata = {
          image_path: this.editdataappend.image_path,
          personal_details: personalDetails,
          educational_qualifications:
            this.editdataappend.educational_qualifications.map(
              (qualification: any) => ({
                id: qualification.id,
                qualification_id: this.isEmployeeFieldVisible(
                  'educational_qualifications',
                  'qualification_id',
                )
                  ? qualification?.qualification_id
                  : '',
                qualification_name: this.isEmployeeFieldVisible(
                  'educational_qualifications',
                  'qualification_name',
                )
                  ? qualification?.qualification
                  : '',
                start_year: this.isEmployeeFieldVisible(
                  'educational_qualifications',
                  'start_year',
                )
                  ? qualification?.start_year
                  : '',
                end_year: this.isEmployeeFieldVisible(
                  'educational_qualifications',
                  'end_year',
                )
                  ? qualification?.end_year
                  : '',
                university_name: this.isEmployeeFieldVisible(
                  'educational_qualifications',
                  'university_name',
                )
                  ? qualification?.university_name
                  : '',
                institution_name: this.isEmployeeFieldVisible(
                  'educational_qualifications',
                  'institution_name',
                )
                  ? qualification?.institution_name
                  : '',
                course_name: this.isEmployeeFieldVisible(
                  'educational_qualifications',
                  'course_name',
                )
                  ? qualification?.course_name
                  : '',
                percentage: this.isEmployeeFieldVisible(
                  'educational_qualifications',
                  'percentage',
                )
                  ? qualification?.percentage
                  : '',
              }),
            ),
          addresses: this.editdataappend.addresses.map((address: any) => ({
            id: address.id,
            country_id: this.isEmployeeFieldVisible('addresses', 'country_id')
              ? address?.country_id
              : '',
            state_id: this.isEmployeeFieldVisible('addresses', 'state_id')
              ? address?.state_id
              : '',
            address_line1: this.isEmployeeFieldVisible(
              'addresses',
              'address_line1',
            )
              ? address?.address_line1
              : '',
            address_line2: this.isEmployeeFieldVisible(
              'addresses',
              'address_line2',
            )
              ? address?.address_line2
              : '',
            pincode: this.isEmployeeFieldVisible('addresses', 'pincode')
              ? address?.pincode
              : '',
            city: this.isEmployeeFieldVisible('addresses', 'city')
              ? address?.city
              : '',
          })),
          experience: this.editdataappend?.experience_details.map(
            (experience: any) => ({
              id: experience.id,
              designation: this.isEmployeeFieldVisible(
                'experience',
                'designation',
              )
                ? experience?.designation
                : '',
              organization_name: this.isEmployeeFieldVisible(
                'experience',
                'organization_name',
              )
                ? experience?.organization_name
                : '',
              start_date: this.isEmployeeFieldVisible(
                'experience',
                'start_date',
              )
                ? experience?.start_date
                : '',
              end_date: this.isEmployeeFieldVisible('experience', 'end_date')
                ? experience?.end_date
                : '',
              location: this.isEmployeeFieldVisible('experience', 'location')
                ? experience?.location
                : '',
            }),
          ),
          scholarly_work: this.editdataappend.research_details.map(
            (scholarly_work: any) => ({
              id: scholarly_work?.id,
              title: this.isEmployeeFieldVisible('scholarly_work', 'title')
                ? scholarly_work?.title
                : '',
              scholarly_work_type_id: this.isEmployeeFieldVisible(
                'scholarly_work',
                'scholarly_work_type_id',
              )
                ? scholarly_work?.scholarly_work_type_id
                : '',
              activity_type: this.isEmployeeFieldVisible(
                'scholarly_work',
                'activity_type',
              )
                ? scholarly_work?.activity_type
                : '',
              platform_id: this.isEmployeeFieldVisible(
                'scholarly_work',
                'platform_id',
              )
                ? scholarly_work?.platform_id
                : '',
              year: this.isEmployeeFieldVisible('scholarly_work', 'year')
                ? scholarly_work?.year
                : '',
              description: this.isEmployeeFieldVisible(
                'scholarly_work',
                'description',
              )
                ? scholarly_work?.description
                : '',
            }),
          ),
          salary_details: {
            pay_scale: this.isEmployeeFieldVisible(
              'salary_details',
              'pay_scale',
            )
              ? this.editdataappend?.salary_details[0]?.pay_scale || ''
              : '',
            pf_number: this.isEmployeeFieldVisible(
              'salary_details',
              'pf_number',
            )
              ? this.editdataappend?.salary_details[0]?.pf_number || ''
              : '',
            esi_number: this.isEmployeeFieldVisible(
              'salary_details',
              'esi_number',
            )
              ? this.editdataappend?.salary_details[0]?.esi_number || ''
              : '',
            salary_mode_id: this.isEmployeeFieldVisible(
              'salary_details',
              'salary_mode_id',
            )
              ? this.editdataappend?.salary_details[0]?.salary_mode_id || ''
              : '',
            gross_pay_per_month: this.isEmployeeFieldVisible(
              'salary_details',
              'gross_pay_per_month',
            )
              ? this.editdataappend?.salary_details[0]?.gross_pay_per_month ||
                ''
              : '',
            hra_in_rupees: this.isEmployeeFieldVisible(
              'salary_details',
              'hra_in_rupees',
            )
              ? this.editdataappend?.salary_details[0]?.hra_in_rupees || ''
              : '',
            basic_pay: this.isEmployeeFieldVisible(
              'salary_details',
              'basic_pay',
            )
              ? this.editdataappend?.salary_details[0]?.basic_pay || ''
              : '',
            other_allowances: this.isEmployeeFieldVisible(
              'salary_details',
              'other_allowances',
            )
              ? this.editdataappend?.salary_details[0]?.other_allowances || ''
              : '',
          },
          bank_details: {
            bank_account_number: this.isEmployeeFieldVisible(
              'bank_details',
              'bank_account_number',
            )
              ? this.editdataappend?.salary_details[0]?.bank_account_number
              : '',
            bank_ifsc_code: this.isEmployeeFieldVisible(
              'bank_details',
              'bank_ifsc_code',
            )
              ? this.editdataappend?.salary_details[0]?.bank_ifsc_code
              : '',
            bank_name: this.isEmployeeFieldVisible('bank_details', 'bank_name')
              ? this.editdataappend?.salary_details[0]?.bank_name
              : '',
            bank_branch_name: this.isEmployeeFieldVisible(
              'bank_details',
              'bank_branch_name',
            )
              ? this.editdataappend?.salary_details[0]?.bank_branch_name
              : '',
          },
          joining_details: {
            professional_email: this.isEmployeeFieldVisible(
              'joining_details',
              'professional_email',
            )
              ? this.editdataappend?.personal_details?.professional_email
              : '',
            // employement_type_id: this.editdataappend?.joining_details.employement_type_id,
            appointment_type_id: this.isEmployeeFieldVisible(
              'joining_details',
              'appointment_type_id',
            )
              ? this.editdataappend?.personal_details?.appointment_type_id
              : '',
            department_id: this.isEmployeeFieldVisible(
              'joining_details',
              'department_id',
            )
              ? this.editdataappend?.personal_details?.department_id
              : '',
            faculty_teaching_for: this.isEmployeeFieldVisible(
              'joining_details',
              'faculty_teaching_for',
            )
              ? this.editdataappend?.personal_details?.faculty_teaching_for
              : '',
            designation_id: this.isEmployeeFieldVisible(
              'joining_details',
              'designation_id',
            )
              ? this.editdataappend?.personal_details?.designation_id
              : '',
            date_of_joining: this.isEmployeeFieldVisible(
              'joining_details',
              'date_of_joining',
            )
              ? this.editdataappend?.personal_details?.date_of_joining
              : '',
            // date_of_relieving: this.editdataappend?.joining_details.date_of_relieving,
            employment_type_id: this.isEmployeeFieldVisible(
              'joining_details',
              'employment_type_id',
            )
              ? this.editdataappend?.personal_details?.employment_type_id
              : '',
          },
        };
        this.EmployeeProfileForm.setValue(editdata?.personal_details);
        this.educationaddformarry.push(...editdata.educational_qualifications);
        this.addressesformarry.push(...editdata.addresses);
        this.experienceaddformarry.push(...editdata.experience);
        this.scholarly_workaddformarry.push(...editdata.scholarly_work);
        this.EmployeeJoiningForm.patchValue(editdata?.joining_details);
        this.EmployeeSalaryForm.setValue(editdata?.salary_details);
        this.EmployeeBankdetailsForm.setValue(editdata?.bank_details);
        this.EmployeePresentAddressForm.patchValue(editdata?.addresses[0]);
        this.EmployeePermanentAddressForm.patchValue(editdata?.addresses[1]);
        this.selectedImageUrl = `${environment.ASSET_URL}${environment.ASSET_CONTAINER}/${editdata.image_path}`;
      });
    // this.apiservice.editEmployeeDetails(editdata, event.id).subscribe(
    //   (employeedata: any) => {
    //     this.EmployeeProfileForm.setValue(editdata?.personal_details);
    //     this.educationaddformarry.push(
    //       ...employeedata.educational_qualifications
    //     );
    //     this.EmployeeExperienceForm.setValue(editdata?.experience_details);
    //     this.EmployeeJoiningForm.setValue(editdata?.joining_details);
    //     this.EmployeeSalaryForm.setValue(editdata?.salary_deatails);
    //     this.EmployeePresentAddressForm.setValue(employeedata?.addresses[0]);
    //     this.EmployeePermanentAddressForm.setValue(employeedata?.addresses[1]);
    //   },
    //   (error: any) => {
    //     console.error('Error updating employee data', error);
    //     // Add error handling logic, like showing a toast notification or a message
    //   }
    // );
  }

  updateEmployee(employeeId: number) {
    let address: any[] = [];
    address.push(this.EmployeePresentAddressForm.getRawValue());
    address.push(this.EmployeePermanentAddressForm.getRawValue());
    const presentAddress = this.EmployeePresentAddressForm.getRawValue();
    this.getcountryname(presentAddress.country_id, 'persent');
    this.getstatename(presentAddress.state_id, 'persent');
    presentAddress.country_name = this.present_selected_country_name;
    presentAddress.state_name = this.present_selected_state_name;
    // address[0].push(presentAddress);
    address[0] = presentAddress;
    // if(!this.checked){
    const permanentAddress = this.EmployeePermanentAddressForm.getRawValue();
    this.getcountryname(permanentAddress.country_id, 'permenent');
    this.getstatename(permanentAddress.state_id, 'permenent');
    permanentAddress.country_name = this.premenent_selected_country_name;
    permanentAddress.state_name = this.premenent_selected_state_name;
    address[1] = permanentAddress;
    address[0].id = this.addressesformarry[0].id;
    address[1].id = this.addressesformarry[1].id;
    // }
    // this.addressesformarry[0] =  this.EmployeePresentAddressForm.getRawValue();
    // this.addressesformarry[1] =  this.EmployeePermanentAddressForm.getRawValue()
    let apiObjecttosend = {
      personal_details: {
        organization_id: parseInt(this.editdataappend.organization_id),
        sub_organization_id: parseInt(this.editdataappend.sub_organization_id),
        employee_unique_id: this.EmployeeProfileForm.value?.employee_unique_id,
        title: this.EmployeeProfileForm.value.title,
        first_name: this.EmployeeProfileForm.value.first_name,
        middle_name: this.EmployeeProfileForm.value.middle_name,
        last_name: this.EmployeeProfileForm.value.last_name,
        personal_email: this.EmployeeProfileForm.value.personal_email,
        father_name: this.EmployeeProfileForm.value.father_name,
        mother_name: this.EmployeeProfileForm.value.mother_name,
        phone_number: this.EmployeeProfileForm.value.phone_number,
        alternate_mobile_number:
          this.EmployeeProfileForm.value.alternate_mobile_number,
        // password: this.EmployeeProfileForm.value.password,
        religion_id: parseInt(this.EmployeeProfileForm.value.religion_id),
        // "religion": this.EmployeeProfileForm.value.religion,
        caste_id: parseInt(this.EmployeeProfileForm.value.caste_id),
        caste: this.EmployeeProfileForm.value.caste,
        sub_caste: this.EmployeeProfileForm.value.sub_caste,
        gender_id: parseInt(this.EmployeeProfileForm.value.gender_id),
        // "gender": this.EmployeeProfileForm.value.gender,
        date_of_birth: this.pipe.transform(
          this.EmployeeProfileForm.value.date_of_birth,
          'yyyy-MM-dd',
        ),
        adhar_number: this.EmployeeProfileForm.value?.adhar_number?.toString(),
        pan_number: this.EmployeeProfileForm.value.pan_number,
        user_roles: this.editdataappend?.personal_details?.user_roles,
        // "user_role": this.EmployeeProfileForm.value.userRole,
        status_id: parseInt(this.EmployeeProfileForm.value.status_id),
        // "status": 'ACTIVE'
      },
      educational_qualifications: this.educationaddformarry,
      addresses: address,
      experience: this.experienceaddformarry,
      scholarly_work: this.scholarly_workaddformarry,
      salary_details: [
        {
          id: this.editdataappend?.salary_details[0]?.id,
          pay_scale: this.EmployeeSalaryForm.value.pay_scale,
          pf_number: this.EmployeeSalaryForm.value?.pf_number?.toString(),
          esi_number: this.EmployeeSalaryForm.value?.esi_number?.toString(),
          salary_mode_id: parseInt(
            this.EmployeeSalaryForm.value.salary_mode_id,
          ),
          //"salary_mode": this.EmployeeSalaryForm.value.salary_mode,
          gross_pay_per_month:
            this.EmployeeSalaryForm.value?.gross_pay_per_month?.toString(),
          hra_in_rupees:
            this.EmployeeSalaryForm.value?.hra_in_rupees?.toString(),
          basic_pay: this.EmployeeSalaryForm.value?.basic_pay?.toString(),
          other_allowances:
            this.EmployeeSalaryForm.value?.other_allowances?.toString(),
          bank_account_number:
            this.EmployeeBankdetailsForm.value?.bank_account_number?.toString(),
          bank_ifsc_code:
            this.EmployeeBankdetailsForm?.value.bank_ifsc_code?.toString(),
          bank_name: this.EmployeeBankdetailsForm.value?.bank_name?.toString(),
          bank_branch_name:
            this.EmployeeBankdetailsForm.value?.bank_branch_name?.toString(),
        },
      ],
      joining_details: {
        employment_type_id: this.EmployeeJoiningForm.value.employment_type_id,
        professional_email: this.EmployeeJoiningForm.value.professional_email,
        // "employement_type": this.EmployeeJoiningForm?.value?.employement_type,
        appointment_type_id: this.EmployeeJoiningForm.value.appointment_type_id,
        // "appointment_type": this.EmployeeJoiningForm?.value?.appointment_type,
        department_id: this.EmployeeJoiningForm.value.department_id,
        // "department_name": this.EmployeeJoiningForm.value.EmployeeJoiningForm,
        faculty_teaching_for:
          this.EmployeeJoiningForm.value.faculty_teaching_for,
        designation_id: this.EmployeeJoiningForm.value.designation_id,
        manager_id: this.EmployeeJoiningForm.value.manager_id,
        // "designation_name": this.EmployeeJoiningForm.value.designation_name,
        date_of_joining: this.pipe.transform(
          this.EmployeeJoiningForm.value.date_of_joining,
          'yyyy-MM-dd',
        ),
        // date_of_relieving: this.pipe.transform(
        //   this.EmployeeJoiningForm.value.date_of_relieving,
        //   'yyyy/MM/dd'
        // ),
      },
    };
    this.apiservice.editEmployeeDetails(apiObjecttosend, employeeId).subscribe(
      (res: any) => {
        if (res.code === '204') {
          // if (!this.connectiveservice.Employee_data) {
          //   this.connectiveservice.Employee_data = undefined;
          //   this.NavigateToBack();
          // } else {
          if (this.file) {
            this.updateImage(
              this.file,
              this.connectiveservice.Employee_data.id,
            );
          }
          this.connectiveservice.Employee_data = undefined;
          this.NavigateToBack();
          this.resetemployeeform();
          this.toast.showToast('success', 'Employee updated successfully');
          // }
        } else {
          this.toast.showToast('danger', `Error: ${res.message}`);
          this.errorMessage = res.message;
        }
      },
      (error) => {
        this.toast.showToast('danger', `Error: ${error.message}`);
      },
    );
  }

  csvInputChange(fileInputEvent: any) {
    this.uploaddata(fileInputEvent.target.files[0]);
  }
  uploaddata(event: any) {
    this.apiservice.bulkuploademployee(event).subscribe((res) => {
      this.getemployeelist();
    });
  }
  openUploadDialog(
    uploadType: 'details' | 'images',
    formDataKey: 'employeImages' | 'EMPLOYEES_BULKUPLOAD_TEMPLATE',
  ): void {
    let excelallowedFileTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];
    let zipallowedFileTypes = [
      'application/zip',
      'application/x-zip-compressed',
    ];
    let allowedFileTypes;
    if (formDataKey == 'EMPLOYEES_BULKUPLOAD_TEMPLATE') {
      allowedFileTypes = excelallowedFileTypes;
    } else {
      allowedFileTypes = zipallowedFileTypes;
    }
    const dialogRef = this.dialog.open(UploadDialogComponent, {
      data: { uploadType, formDataKey, allowedFileTypes },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  pagination(event: any) {
    this.paginationdata = event;
    this.getemployeelist();
    this.filterEmployees(event);
  }

  NavigateToBack() {
    this.resetemployeeform();
    this.connectiveservice.Employee_data = undefined;
    this.location.back();
  }
  getscholarly_work(event: any) {
    return this.EmployeeService.Scholarlyworkdata.find(
      (e: any) => e.id == event,
    )?.key;
  }
  getactivitydata(event: any) {
    return this.EmployeeService.Activitydata.find((e: any) => e.id == event)
      ?.key;
  }
  getplatformdata(event: any) {
    return this.EmployeeService.Platformdata.find((e: any) => e.id == event)
      ?.key;
  }
}
